// import logo from './logo.svg';
import './App.css';
import Header from "./mycomponents/Header";
import AddTodo from './mycomponents/AddTodo';
import Todos from "./mycomponents/Todos";
import Footer from "./mycomponents/Footer";
// import TodoItem from "./mycomponents/TodoItem";
// import { About } from "./mycomponents/About";
import React, { useState, useEffect } from 'react';

function App() {

  const [mode, setMode] = useState('light');//dark mode on or off

  const togglemode=()=>{
    if(mode === 'light'){
      setMode('dark');
      document.body.style.backgroundColor = '#131417';
    }
    else{
      setMode('light');
      document.body.style.backgroundColor = '#EEEEEE';
    }
  }

  let initTodo;
  if (localStorage.getItem("todos") === null) {
    initTodo = [];
  }
  else {
    initTodo = JSON.parse(localStorage.getItem("todos"));
  }
  const onDelete = (todo) => {
    console.log("I am onDeleted of todo", todo);

    setTodos(todos.filter((b) => {
      return b !== todo;
    }));

    localStorage.setItem("todos", JSON.stringify(todos));
  }

  const addTodo = (title, desc) => {
    console.log("I am adding a todo", title, desc);
    let sno;
    if (todos.length === 0) {
      sno = 0;
    }
    else {
      sno = todos[todos.length - 1].sno + 1;
    }
    const myTodo = {
      sno: sno,
      title: title,
      desc: desc
    }
    setTodos([...todos, myTodo]);
    console.log(myTodo);

  }

  const [todos, setTodos] = useState(initTodo);
  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));

  }, [todos])


  return (
    <>
      <Header title="  ToDOList" searchbar={false} mode = {mode} togglemode={togglemode}/>
      <AddTodo addTodo={addTodo} mode = {mode} />
      {/* <TodoItem mode = {mode}/> */}
      <Todos todos={todos} onDelete={onDelete} mode = {mode} />
      <Footer />
    </>
  );
}

export default App;
